import { Box, FloraTypography } from '@grupoboticario/flora-react'

import { EVENT_TYPES } from '@/constants/benefitIds'
import { PREVIEW_LABELS } from '@/constants/eventPreviewLabels'
import { sanitizeHtmlContent } from '@/utils/htmlHelpers/htmlHelpers'

import CollapsibleSection from './CollapsibleSection'
import { DetailsSectionProps } from './DetailsSection.types'
import ImagePreview from './ImagePreview'
import InfoField from './InfoField'
import {
  descriptionContainerStyle,
  descriptionTitleStyle,
  descriptionValueStyle,
  imageContainerStyle,
  imageTitleStyle,
  detailsSectionContentStyle
} from './styles'

const DetailsSection = ({ isOpen, onToggle, eventTypeLabel, formValues, imagePreviewUrl }: DetailsSectionProps) => (
  <CollapsibleSection isOpen={isOpen} onToggle={onToggle} title={PREVIEW_LABELS.SECTION_DETAILS}>
    <Box css={detailsSectionContentStyle}>
      <InfoField label={PREVIEW_LABELS.FIELD_TYPE} value={eventTypeLabel} />
      <InfoField label={PREVIEW_LABELS.FIELD_NAME} value={formValues.name || PREVIEW_LABELS.NO_INFO} />

      {formValues.type === EVENT_TYPES.EXCLUSIVE_EVENTS && (
        <InfoField
          label={PREVIEW_LABELS.FIELD_LIMIT_PER_CPF_EVENT}
          value={formValues.eventLimitPerCpf ? String(formValues.eventLimitPerCpf) : PREVIEW_LABELS.NO_INFO}
        />
      )}

      <Box css={descriptionContainerStyle}>
        <FloraTypography css={descriptionTitleStyle} as="span" fontSize="bodyLargeStandard" fontWeight="bold">
          {PREVIEW_LABELS.FIELD_DESCRIPTION}
        </FloraTypography>
        <FloraTypography css={descriptionValueStyle} as="span" fontSize="bodyLargeStandard">
          {sanitizeHtmlContent(formValues.description ?? '') || PREVIEW_LABELS.NO_INFO}
        </FloraTypography>
      </Box>

      <Box css={imageContainerStyle}>
        <FloraTypography css={imageTitleStyle} fontSize="bodyLargeStandard" fontWeight="bold">
          {PREVIEW_LABELS.FIELD_IMAGE}
        </FloraTypography>
        <ImagePreview imageUrl={imagePreviewUrl} />
      </Box>
    </Box>
  </CollapsibleSection>
)

export default DetailsSection
